<script>
  import HeaderMini from "../components/HeaderMini.svelte";
  import Footer from "../components/Footer.svelte";
  import { Pagination } from "spaper";
  import { navigate } from "svelte-routing";
  import { surveyFilters } from "../stores/stores";
  import { Icon } from "svelte-awesome";
  import {
    faDog,
    faCat,
    faVenus,
    faMars,
    faChild,
    faMale,
    faPaw,
    faBan,
    faExchangeAlt
  } from "@fortawesome/free-solid-svg-icons";

  const iconStyle = {
    enabled: "color: black",
    disabled: "color: rgb(194, 194, 194)"
  };

  const filters = {
    male: false,
    dog: false,
    kids: false,
    pets: false,
  };

  const questions = [
    'Especie',
    'Sexo',
    'Niños',
    'Mascotas',
    '¡Vamos!'
  ];

  let currentQuestion = 1;
  const showQuestion = (ev) => {
    updateFilters();
    currentQuestion = ev.detail;
  }

  const updateFilters = () => {
    let currentFilters = [];
    currentFilters.push(filters.male ? "sex=male" : "sex=female");
    currentFilters.push(filters.dog ? "kind=dog" : "kind=cat");
    if (filters.kids) currentFilters.push("likeschildren=true");
    if (filters.pets) currentFilters.push("likesotherpets=true");
    surveyFilters.set(currentFilters.join("&"));
  };

  const swapValues = (field) => {
    filters[field] = !filters[field];
  };

  const showAdoptables = () => { navigate("/adoptables") };
</script>

<HeaderMini />
<div class="survey">
  {#if currentQuestion == 1}
    <div class="row">
      <div class="col-12 col">
        <h3>¿Qué estás buscando?</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-fill col" >
        <Icon scale="4" data={faDog} style={filters.dog ? iconStyle.enabled : iconStyle.disabled} />
        <p style={filters.dog ? iconStyle.enabled : iconStyle.disabled}>Perro</p>
      </div>
      <div class="col-fill col">
        <button class="btn-paper primary" on:click={() => swapValues('dog')}>
          <Icon scale="2" data={faExchangeAlt} />
        </button>
      </div>
      <div class="col-fill col">
        <Icon scale="4" data={faCat} style={filters.dog ? iconStyle.disabled : iconStyle.enabled} />
        <p style={filters.dog ? iconStyle.disabled : iconStyle.enabled}>Gato</p>
      </div>
    </div>
  {:else if currentQuestion == 2}
    <div class="row">
      <div class="col-12 col">
        <h3>¿Prefieres macho o hembra?</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-fill col" >
        <Icon scale="4" data={faMars} style={filters.male ? iconStyle.enabled : iconStyle.disabled} />
        <p style={filters.male ? iconStyle.enabled : iconStyle.disabled}>Macho</p>
      </div>
      <div class="col-fill col">
        <button class="btn-paper primary" on:click={() => swapValues('male')}>
          <Icon scale="2" data={faExchangeAlt} />
        </button>
      </div>
      <div class="col-fill col">
        <Icon scale="4" data={faVenus} style={filters.male ? iconStyle.disabled : iconStyle.enabled} />
        <p style={filters.male ? iconStyle.disabled : iconStyle.enabled}>Hembra</p>
      </div>
    </div>
  {:else if currentQuestion == 3}
    <div class="row">
      <div class="col-12 col">
        <h3>¿Viven niños contigo?</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-fill col" >
        <Icon scale="4" data={faChild} style={filters.kids ? iconStyle.enabled : iconStyle.disabled} />
        <p style={filters.kids ? iconStyle.enabled : iconStyle.disabled}>Sí</p>
      </div>
      <div class="col-fill col">
        <button class="btn-paper primary" on:click={() => swapValues('kids')}>
          <Icon scale="2" data={faExchangeAlt} />
        </button>
      </div>
      <div class="col-fill col">
        <Icon scale="4" data={faMale} style={filters.kids ? iconStyle.disabled : iconStyle.enabled} />
        <p style={filters.kids ? iconStyle.disabled : iconStyle.enabled}>No</p>
      </div>
    </div>
  {:else if currentQuestion == 4}
    <div class="row">
      <div class="col-12 col">
        <h3>¿Tienes otras mascotas?</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-fill col" >
        <Icon scale="4" data={faPaw} style={filters.pets ? iconStyle.enabled : iconStyle.disabled} />
        <p style={filters.pets ? iconStyle.enabled : iconStyle.disabled}>Sí</p>
      </div>
      <div class="col-fill col">
        <button class="btn-paper primary" on:click={() => swapValues('pets')}>
          <Icon scale="2" data={faExchangeAlt} />
        </button>
      </div>
      <div class="col-fill col">
        <Icon scale="4" data={faBan} style={filters.pets ? iconStyle.disabled : iconStyle.enabled} />
        <p style={filters.pets ? iconStyle.disabled : iconStyle.enabled}>No</p>
      </div>
    </div>
  {:else if currentQuestion == 5}
    <div class="row">
      <div class="col-12 col">
        <h3>¡Todo listo para encontrar a tu mascota ideal!</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-fill col">
        <button class="btn-paper primary" on:click={showAdoptables}>
          ¡Encontrar Ya!
        </button>
      </div>
    </div>
  {/if}
  <Pagination simple pageSize=1 total={questions.length} on:change={showQuestion} />
</div>
<Footer />

<style>
  .survey {
    text-align: center;
    display: block;
    margin: auto;
    padding-bottom: 3%;
  }
</style>
